__turbopack_context__.v({
  "list": "CompletedToolsSummary-module__y8Hvlq__list",
  "toggle": "CompletedToolsSummary-module__y8Hvlq__toggle",
});
